import type { AppointmentStatus, AppointmentView } from "@shared/modules/x-atelier";

/** Variantes de `Badge` du noyau (le type n'y est pas exporté). */
export type BadgeVariant = "neutral" | "primary" | "success" | "warning" | "danger";

/** Couleurs de statut : tokens seulement, via les variantes de pastille du noyau. */
export const STATUS_VARIANT: Record<AppointmentStatus, BadgeVariant> = {
  devis: "neutral",
  reserve: "primary",
  confirme: "primary",
  vehicule_recu: "warning",
  en_cours: "warning",
  termine: "success",
  pret: "success",
  recupere: "success",
  annule: "danger",
  non_presente: "danger",
};

/** Statuts qui ne comptent ni dans les totaux ni dans la charge de travail. */
export const INACTIVE_STATUSES: AppointmentStatus[] = ["annule", "non_presente"];

export function isInactive(status: AppointmentStatus): boolean {
  return INACTIVE_STATUSES.includes(status);
}

/**
 * Montant restant dû, tel que servi par l'API (total TTC − payé, jamais
 * négatif). Plus aucun calcul ici : les taxes ne se devinent pas côté web.
 */
export function dueCents(a: Pick<AppointmentView, "dueCents">): number {
  return a.dueCents;
}
